module.exports = __webpack_public_path__ + "static/compass-banner-01cf9f5df9dd576a2ab09c7f3a6778e7.png";